export default __webpack_public_path__ + "media/images/logo_white-b0d43a08df4e486f5c8f84254697d622.png";